import { DIV } from 'sdi/components/elements';
import { inputLongText } from 'sdi/components/input';
import { markdown } from 'sdi/ports/marked';
import { cancelButton, renderButtonEdit, saveButton } from './buttons';
import { Option } from 'fp-ts/lib/Option';
import { pair } from 'sdi/lib';
import {
    setTextForm,
    clearTextForm,
    setEditStatus,
    setNewTextEdit,
} from '../events/app';
import { getTextForm, getEditStatusBool } from '../queries/app';

export const renderEditable = <T>(
    key: string,
    obj: T,
    setText: (obj: T, text: string | number) => void,
    deleteText: (obj: T) => void
) =>
    DIV(
        {
            className: `issue-field-value editable`,
        },
        inputLongText(() => getTextForm().getOrElse(''), setTextForm, {
            className: 'value',
            key: `text-form-value`,
        }),
        cancelButton(() => {
            clearTextForm();
            setEditStatus(pair(key, false));
            setNewTextEdit(false);
        }),
        saveButton(() => {
            getTextForm().foldL(
                () => deleteText(obj),
                cf => setText(obj, cf)
            );
            clearTextForm();
            setEditStatus(pair(key, false));
            setNewTextEdit(false);
        })
    );

export const renderReadonly = <T>(
    key: string,
    obj: T,
    getText: (obj: T) => Option<string>
) =>
    DIV(
        {
            className: `issue-field-value`,
            onClick: () => {
                setEditStatus(pair(key, true));
                setTextForm(getText(obj).getOrElse(''));
            },
        },
        getText(obj).foldL(
            () =>
                renderButtonEdit(() => {
                    setEditStatus(pair(key, true));
                    setTextForm(getText(obj).getOrElse(''));
                }),
            t => markdown(t)
        )
    );

export const renderEditableText = <T>(
    key: string,
    obj: T,
    setText: (obj: T, text: string) => void,
    getText: (obj: T) => Option<string>,
    deleteText: (obj: T) => void
) =>
    getEditStatusBool(key)
        ? renderEditable(key, obj, setText, deleteText)
        : renderReadonly(key, obj, getText);

// export const renderResolvingChangeset = (
//     key: string,
//     obj: Issue,
//     setText: (obj: Issue, changesetId: number) => void
// ) => getEditStatusBool(key) ? renderEditable(key, obj, setText, (_obj) => { }) : renderAddChangesetButton(() => setEditStatus(pair(key, true)));
